/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNavigate } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import { IDealerChangedEvent, IPageProps, IRootState, } from 'types'
import { AddButton, FormInput, PageHeader, ReturnButton } from 'components'
import { CreateFrazerPayMerchantDto } from 'generated/v1/v1IntegrationsApi'
import { useRef, useState } from 'react'
import { FormElement, Field, Form, FormClassComponent, } from '@progress/kendo-react-form'
import { useDispatch, useSelector } from 'react-redux'
import { endLoadingAction, startLoadingAction } from 'state/actions/appActions'
import { V1ApiIntegrationsClient } from 'core/http-common'
import { AppDispatch } from 'state/store'
import toast from 'core/toast'
import { RequiredValidator } from 'core/Validators'
import DealerSelect from 'components/Dealers/DealerSelect'

const MerchantsAddPage = ({ title }: IPageProps) => {

    const redirectUrl = '/merchants'

    const formRef = useRef<FormClassComponent>(null)
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()

    const loading = useSelector((state: IRootState) => state.app.loading)
    const [selectedDealerId, setSelectedDealerId] = useState<number | undefined>()

    const handleSubmit = async (values: any) => {
        try {
            await dispatch(startLoadingAction())

            if (selectedDealerId) {
                values.dealerId = selectedDealerId
            }

            await V1ApiIntegrationsClient.createFrazerPayMerchant(
                new CreateFrazerPayMerchantDto({
                    dealerId: values.dealerId,
                    paymentProcessorCcMerchantId: values.paymentProcessorCcMerchantId,
                    paymentProcessorMerchantUsername: values.paymentProcessorMerchantUsername,
                    paymentProcessorMerchantPassword: values.paymentProcessorMerchantPassword
                }))

            toast.success('Frazer Pay Merchant was successfully created.')
            navigate(redirectUrl)

        } catch (e) {
            toast.responseErrors(e)
        }
        finally {
            await dispatch(endLoadingAction())
        }
    }

    const handleDealerClear = async () => {
        setSelectedDealerId(undefined)
    }

    const handleDealerChange = async (e: IDealerChangedEvent) => {
        setSelectedDealerId(e.dealerId)
    }

    return (
        <div>
            <PageHeader title={title}>
                <ReturnButton redirectUrl='/merchants' />
            </PageHeader>

            <Form
                onSubmit={handleSubmit}
                ref={formRef}
                ignoreModified={true}
                render={(formRenderProps) => (
                    <FormElement>
                        <div className='bg-light border p-3'>
                            <Row className='mb-3'>
                                <Col md={4} className='mb-3 mb-md-0'>
                                    <Field
                                        className='form-control'
                                        dataItemKey='id'
                                        textField='text'
                                        name='dealer'
                                        label='Dealer:'
                                        required
                                        dealerId={selectedDealerId ?? 0}
                                        component={DealerSelect}
                                        onDealerCleared={handleDealerClear}
                                        onDealerChanged={handleDealerChange}
                                    />
                                </Col>
                                <Col md={4}>
                                    <Field
                                        label='CC Merchant ID:'
                                        name='paymentProcessorCcMerchantId'
                                        validator={RequiredValidator}
                                        required
                                        component={FormInput}
                                    />
                                </Col>
                                <Col md={4}>
                                    <Field
                                        label='Merchant Username:'
                                        name='paymentProcessorMerchantUsername'
                                        component={FormInput}
                                        validator={RequiredValidator}
                                    />
                                </Col>
                                <Col md={4}>
                                    <Field
                                        label='Merchant Password:'
                                        name='paymentProcessorMerchantPassword'
                                        component={FormInput}
                                        validator={RequiredValidator}
                                    />
                                </Col>
                                <Row className='mt-3'>
                                    <Col xs={12} sm={4}>
                                        <AddButton
                                            disabled={!formRenderProps.allowSubmit || loading}
                                            type='submit'
                                        />
                                    </Col>
                                </Row>
                            </Row>
                        </div>
                    </FormElement>
                )
                }
            />
        </div>
    )
}
export default MerchantsAddPage
